var testAnimation = function testAnimation(keyframes, options) {
  return document.createElement("div").animate(keyframes, options);
};
var featureTests = {
  cssRegisterProperty: function cssRegisterProperty() {
    return typeof CSS !== "undefined" && Object.hasOwnProperty.call(CSS, "registerProperty");
  },
  waapi: function waapi() {
    return Object.hasOwnProperty.call(Element.prototype, "animate");
  },
  partialKeyframes: function partialKeyframes() {
    try {
      testAnimation({
        opacity: [1]
      });
    } catch (e) {
      return false;
    }
    return true;
  },
  finished: function finished() {
    return Boolean(testAnimation({
      opacity: [0, 1]
    }, {
      duration: 0.001
    }).finished);
  },
  linearEasing: function linearEasing() {
    try {
      testAnimation({
        opacity: 0
      }, {
        easing: "linear(0, 1)"
      });
    } catch (e) {
      return false;
    }
    return true;
  }
};
var results = {};
var supports = {};
var _loop = function _loop(key) {
  supports[key] = function () {
    if (results[key] === undefined) results[key] = featureTests[key]();
    return results[key];
  };
};
for (var key in featureTests) {
  _loop(key);
}
export { supports };